import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import './index.scss';
import { LIST_TYPES, NOT_COMPARED_PAGE_SIZE, SECTION_TEXT } from '../../../../constants';
import { buildProjectComparisonPayload } from '../../../../utils/buildProjectComparisonPayload';
import NotComparedRow from './children/NotComparedRow';

// Its own scrollport, separate from the Compared table's — see that component.
const SCROLL_ID = 'trend-not-compared-scroll';

const WarningIcon = () => (
    <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
        <path d='M12 4.2L2.6 19.4h18.8z' />
        <path d='M12 10v4.2' />
        <path d='M12 17.1h.01' />
    </svg>
);

const NotComparedTable = (props) => {
    const api = props.fetchProjectNotComparedApi || {};
    const { searchText } = props;
    // Leaders exactly as the API sends them — rendered as-is, no reshaping.
    const leaders = api.data || [];

    // Next page of this list; `from` is how many leaders it already has loaded.
    const fetchPage = (from) => {
        props.getProjectComparison(buildProjectComparisonPayload({
            benchmarkFiltersAnalysis: props.benchmarkFiltersAnalysis,
            listType: LIST_TYPES.NOT_COMPARED,
            from,
            size: NOT_COMPARED_PAGE_SIZE,
            searchText,
        }));
    }

    // The first page (on open, search, filter change) is fetched by
    // ComparisonView for both lists at once; this table only pages onwards.
    // A request already in flight, or nothing left to fetch, is a no-op.
    const handleLoadMore = () => {
        if (api.isProcessing || api.isLoadingMore || !api.hasMore) return;
        fetchPage(leaders.length);
    }

    // Exact from the API (`totalLeaders`), and already narrowed by the search.
    const totalCount = api.totalLeaders != null ? api.totalLeaders : leaders.length;

    // Shown only when there are not-compared leaders to list — no rows (everyone
    // matched, a search with no hits, or a failed fetch) keeps the section away.
    // While a search reloads it, it shows "Loading participants…" (the first
    // load is covered by ComparisonView's graph loader).
    if (!api.isProcessing && !leaders.length) return null;

    const renderBody = () => {
        if (api.isProcessing) return <div className='trend-table__empty'>{SECTION_TEXT.notCompared.loading}</div>;
        return (
            <div className='trend-table__body' id={SCROLL_ID}>
                <InfiniteScroll
                    dataLength={leaders.length}
                    next={handleLoadMore}
                    hasMore={!!api.hasMore}
                    scrollableTarget={SCROLL_ID}
                    scrollThreshold={0.9}
                    loader={<div className='trend-table__loader'>Loading more participants…</div>}
                >
                    {/* Leaders keep their object identity across pages (the
                        reducer appends), so loading more mounts only the new rows. */}
                    {leaders.map((leader) => (
                        <NotComparedRow key={leader.selfEmail} leader={leader} />
                    ))}
                </InfiniteScroll>
            </div>
        );
    };

    return (
        <div className='trend-table trend-notcompared'>
            <div className='trend-table__head'>
                <span className='trend-table__head-title'>
                    <span className='trend-table__head-icon'><WarningIcon /></span>
                    {SECTION_TEXT.notCompared.title}
                </span>
                {!api.isProcessing && (
                    <span className='trend-table__badge'>{leaders.length} of {totalCount}</span>
                )}
            </div>

            {renderBody()}
        </div>
    );
};

export default NotComparedTable;
